module.exports = __webpack_public_path__ + "static/langojango-spanish-language-phrasebook-a2bef57e5965cabedad8e6a4eeb10aa2.png";